import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Text } from '../../..';
import MHPhotoStudioIcon from '../../assets/MHPhotoStudioIcon.svg?url';
import MHVideoMakerIcon from '../../assets/MHVideoMakerIcon.svg?url';
import { MediaHomeEditService } from '../EditImagesAndVideoSection.types';
import styles from './CreateNewMedia.scss';
import { IInner, IOuter } from './CreateNewMedia.types';

const editServiceData = {
  [MediaHomeEditService.VideoMaker]: {
    serviceName: 'media-home.edit-images-and-videos.service-name.video-maker',
    serviceDescription: 'media-home.edit-images-and-videos.service-description.video-maker',
    itemIcon: MHVideoMakerIcon,
  },
  [MediaHomeEditService.PhotoStudio]: {
    serviceName: 'media-home.edit-images-and-videos.service-name.photo-studio',
    serviceDescription: 'media-home.edit-images-and-videos.service-description.photo-studio',
    itemIcon: MHPhotoStudioIcon,
  },
};

export const CreateNewMedia: FC<IOuter & IInner> = ({ editServiceName, onClick }) => {
  const openButtonText = <FormattedMessage id="media-home.edit-images-and-videos.button" />;

  const { itemIcon, serviceName, serviceDescription } = editServiceData[editServiceName];

  return (
    <div className={styles.editItem} onClick={onClick} data-hook={`empty-${editServiceName}-section`}>
      <div className={styles.editItemDescription}>
        <img className={styles.iconHolder} src={itemIcon} />

        <div className={styles.serviceDescription}>
          <Text weight="bold" size="medium" className={styles.serviceName}>
            <FormattedMessage id={serviceName} />
          </Text>

          <Text weight="thin" size="tiny" secondary light>
            <FormattedMessage id={serviceDescription} />
          </Text>
        </div>
      </div>

      <div className={styles.buttonsHolder}>
        <Button size="tiny" skin="light" className={styles.lightButton}>
          {openButtonText}
        </Button>

        <Button size="tiny" skin="standard" className={styles.standardButton}>
          {openButtonText}
        </Button>
      </div>
    </div>
  );
};
